import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import CoreuiVue from '@coreui/vue'
import CIcon from '@coreui/icons-vue'
import { iconsSet as icons } from '@/assets/icons'
import { CirclesToRhombusesSpinner } from 'epic-spinners'

import {
  Chart,
  LineController,
  LineElement,
  PointElement,
  LinearScale,
  LogarithmicScale,
  CategoryScale,
  Title,
  BarElement,
  Legend,
  Tooltip,
} from 'chart.js'
Chart.register(
  LineController,
  LineElement,
  BarElement,
  PointElement,
  LinearScale,
  CategoryScale,
  LogarithmicScale,
  Title,
  Legend,
  Tooltip,
)

const app = createApp(App)

const INSTRUCTION_ACK_EXEMPT_ROUTES = new Set([
  'FreelancerInstructionAck',
  'Logout',
  'Login',
])

router.beforeEach(async (to, from, next) => {
  if (store.getters.loggedIn && !INSTRUCTION_ACK_EXEMPT_ROUTES.has(to.name)) {
    const mustAcknowledge = await store.dispatch('ensureInstructionAckStatus')
    if (mustAcknowledge) {
      next({ name: 'FreelancerInstructionAck' })
      return
    }
  }
  if (store.getters.loggedIn && to.name === 'FreelancerInstructionAck') {
    const mustAcknowledge = await store.dispatch('ensureInstructionAckStatus')
    if (!mustAcknowledge) {
      next({ name: 'Showcase' })
      return
    }
  }
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!store.getters.loggedIn) {
      next({ name: 'Login', query: { next: to.fullPath } })
    } else {
      next()
    }
  } else if (to.matched.some((record) => record.meta.requiresNotAuth)) {
    if (store.getters.loggedIn) {
      next({ name: 'Showcase' })
    } else {
      next()
    }
  } else {
    next()
  }
})

app.use(store)
app.use(router)
app.use(CoreuiVue)
app.provide('icons', icons)
app.component('CIcon', CIcon)
app.component('CirclesToRhombusesSpinner', CirclesToRhombusesSpinner)
app.mount('#app')
